import React, { useEffect, useState } from "react";
import { Table, Button, Checkbox, Input, Modal, Spin, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { FaChevronDown } from "react-icons/fa";
import "./BidRequest.css";
import { IoMdClose } from "react-icons/io";
import filterIcon from "../../../assets/icons/filter.svg";

import { useNavigate } from "react-router-dom";
import sortIcon from "../../../assets/icons/sort.svg";
import { MdCircle, MdOutlineCircle } from "react-icons/md";
import FilterModal from "./FilterModal";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../Pagination";
import moment from "moment";
import { getAllBidRequest } from "../../../api/CommonRequest";

const { Search } = Input;

const BidRequest = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchTerm, setSearchTerm] = useState(searchValue);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [subCategory, setSubCategory] = useState([]);
  const [limit, setLimit] = useState(10);
  const [type, setType] = useState(null);
  const [bidRange, setBidRange] = useState([1000, 10000000]);
  const [loader, setLoader] = useState(false);
  const [bids, setBids] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(5);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [trigger, setTrigger] = useState(false);
  console.log(bids);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const [sortBy, setSortBy] = useState({
    key: "1",
    label: "Recently added",
    value: "createdDate:desc",

    icon: <MdCircle size={20} />,
  });

  useEffect(() => {
    const bidRequestCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllBidRequest({
          q: searchTerm,
          subCategory: subCategory,
          bidRange: bidRange,
          type: type === "Public" ? true : type === "Group" ? false : null,
          sort: sortBy.value,
          page: currentPage,
          limit: limit,
        });
        if (data?.success) {
          console.log(data);
          setBids(data?.bidList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        message.error(error.message);
        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    bidRequestCall();
  }, [
    searchTerm,
    sortBy,
    limit,
    currentPage,
    subCategory,
    type,
    bidRange,
    trigger,
  ]);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  // ------ SORT BY ITEMS--------
  const sortItems = [
    {
      key: "1",
      label: "Recently added",
      value: "createdAt:desc",
      icon:
        sortBy.key === "1" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "2",
      label: "Price-High to Low",
      value: "expectedPrice:desc",
      icon:
        sortBy.key === "2" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "3",
      label: "Price-Low to High",
      value: "expectedPrice:asc",
      icon:
        sortBy.key === "3" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "4",
      label: "early added",
      value: "createdAt:asc",
      icon:
        sortBy.key === "4" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
  ];

  const handleSort = (item) => {
    setSortBy(item);
  };
  const handleRemoveCategory = (categoryToRemove) => {
    setSubCategory(subCategory.filter((filter) => filter !== categoryToRemove));
  };

  const handleClearFilter = () => {
    setSubCategory([]);
    setType("All");
    setBidRange([1000, 100000]);
  };
  const onSearch = (value) => setSearchTerm(value);

  const handleViewDetail = (ID) => {
    navigate("/bid-detailed-view", { state: ID });
  };

  const columns = [
    {
      title: () => <Checkbox />,
      key: "select",
      render: () => <Checkbox />,
      width: 50,
    },
    {
      title: <div className="flex items-center gap-2">Product Title</div>,
      dataIndex: "productName",
      key: "productName",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Category</div>,
      dataIndex: "category",
      key: "category",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Sub Category</div>,
      dataIndex: "subCategory",
      key: "subCategory",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Client Name</div>,
      dataIndex: "clientName",
      key: "clientName",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Surveyor Name</div>,
      dataIndex: "surveyorName",
      key: "surveyorName",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },

    {
      title: <div className="flex items-center gap-2">Expected Price</div>,
      dataIndex: "expectedPrice",
      key: "expectedPrice",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Created At</div>,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">
          {moment(text).format("DD-MM-YYYY")}
        </span>
      ),
    },

    {
      title: "Detailed View",
      key: "actions",
      dataIndex: "action",

      align: "center",
      render: (_, record) => (
        <div className="flex space-x-2 justify-center">
          <Button
            onClick={() => handleViewDetail(record._id)}
            icon={<EyeOutlined />}
            className="bg-[#0445C3] text-white hover:border-[#0445C3]"
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex-grow overflow-y-auto scrollbar-hide">
        {/* ------- FILTER-------- */}
        <div className="flex flex-col lg:flex-row gap-3 items-start lg:items-center my-4 px-4 lg:px-0">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full lg:w-auto">
            <div className="w-full sm:w-80">
              <Search
                defaultValue={searchValue}
                placeholder="Search Bids, Category etc..."
                allowClear
                onSearch={onSearch}
                className="w-full"
                size="middle"
              />
            </div>
            <div className="flex gap-2 items-center w-full sm:w-auto">
              <div className="relative flex-1 sm:w-48">
                <button
                  className="bg-white flex w-full h-10 items-center justify-between rounded-[6px] border border-[#A3BBFF] px-4 hover:border-[#1955EB] transition-colors"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <div className="flex items-center gap-2">
                    <img src={sortIcon} alt="Sort Icon" className="w-4" />
                    <span className="text-sm font-medium text-gray-700">Sort By</span>
                  </div>
                  <FaChevronDown
                    className={`transition-transform duration-300 ${isOpen ? "transform rotate-180" : ""
                      }`}
                  />
                </button>
                {isOpen && (
                  <ul className="absolute left-0 mt-2 w-full min-w-[180px] bg-white border border-gray-100 shadow-xl rounded-xl z-[100] py-1">
                    {sortItems.map((item) => (
                      <li
                        key={item.key}
                        onClick={() => {
                          handleSort(item);
                          setIsOpen(false);
                        }}
                        className="flex items-center gap-3 p-3 hover:bg-blue-50 cursor-pointer group transition-colors"
                      >
                        <span className="text-blue-500">{item.icon}</span>
                        <span className="text-sm font-semibold text-gray-700 group-hover:text-[#1955EB]">
                          {item.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <button
                className="bg-white flex-1 sm:w-auto flex items-center justify-center gap-2 rounded-[6px] h-10 px-6 border border-[#A3BBFF] hover:border-[#1955EB] hover:bg-blue-50 transition-all shadow-sm"
                onClick={() => setIsModalVisible(true)}
              >
                <img src={filterIcon} alt="filter" className="w-4" />
                <span className="text-sm font-medium text-gray-700">Filter</span>
              </button>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 w-full lg:w-auto">
            {subCategory.map((filter, index) => (
              <div
                key={index}
                className="flex items-center bg-blue-50 text-[#1955EB] px-3 py-1 rounded-lg border border-blue-100 text-xs font-semibold shadow-sm"
                onClick={() => handleRemoveCategory(filter)}
              >
                <span>{filter}</span>
                <span className="ml-2 text-red-500 font-bold">&times;</span>
              </div>
            ))}
            {subCategory.length > 0 && (
              <button
                className="text-[#1955EB] text-xs font-bold hover:underline px-1"
                onClick={() => handleClearFilter()}
              >
                Clear All
              </button>
            )}
          </div>
        </div>
        <Spin spinning={loader}>
          <div className="pt-[0px] ">
            <Table
              columns={columns}
              dataSource={bids}
              pagination={false}
              className="custom-table-header lg:w-full"
              scroll={{ x: 'max-content' }}
            />
            <div className="">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                totalItem={totalItems}
                onPageChange={handlePageChange}
                handleLimit={handleLimit}
              />
            </div>

            <FilterModal
              isVisible={isModalVisible}
              onClose={() => setIsModalVisible(false)}
              setSubCategory={setSubCategory}
              subCategory={subCategory}
              type={type}
              setType={setType}
              bidRange={bidRange}
              setBidRange={setBidRange}
            />
            <Modal
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              className=""
            >
              <div className="flex flex-col items-center py-3">
                <div className="flex items-center mb-4">
                  <IoMdClose className="text-white p-1 rounded-full bg-[#FF4545] text-4xl" />
                </div>
                <div className="text-center text-[16px] font-medium">
                  <p className="text-[#C7C7C7] text-[16px] font-medium">
                    Survey #4345892394
                  </p>
                  <p className="text-[#313131] text-[24px] font-medium">
                    Survey Request Rejected
                  </p>
                </div>
                <div className="flex justify-center items-center gap-4 w-full  mt-5">
                  <Input
                    type="text"
                    placeholder="Write reason"
                    className="border border-[#9FACF0] h-10 rounded-[8px] p-2 text-[16px] "
                  />

                  <div className="flex">
                    <Button
                      onClick={handleCancel}
                      className="bg-[#1955EB] lg:w-28 rounded-[8px] h-10 text-white text-[18px] font-medium"
                    >
                      Send
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </Spin>
      </div>
    </>
  );
};

export default BidRequest;
